import { CommodityFreightType } from 'types/orderCommodity.types'

export const FREIGHT_TYPE_OPTIONS: {
    value: CommodityFreightType
    label: string
}[] = [
    { value: 'skid', label: 'Skid' },
    { value: 'carton', label: 'Carton' },
    { value: 'bundle', label: 'Bundle' },
    { value: 'package', label: 'Package' },
    { value: 'container', label: 'Container' },
    { value: 'crate', label: 'Crate' },
    { value: 'pallet', label: 'Pallet' },
    { value: 'case', label: 'Case' },
    { value: 'other', label: 'Other' },
]
